
export const PATHS = {
  ROOT: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  INFO: "/info",
  TAGS: "/tags",
  COURSES: "/courses",
  COURSE: "/courses/:id",
  COURSE_CREATE: "/courses/create",
  PEOPLE: "/people",
  PERSON: "/people/:id",
  PEOPLE_CREATE: "/people/create",
  ONBOARDING: "/onboarding",
  ADMIN_TOOLS: "/admin",
  DASHBOARD: "/dashboard",
  ATTENDANCE: "/attendance",
  LOGOUT: "/logout",
}
